import { call, put, takeEvery, fork, select } from 'redux-saga/effects'
import { types, ILogoutAction } from '../types/auth'
import * as actions from '../actions/auth'
import * as selectors from '../selectors/auth'
import * as services from '../services/auth'
import { trace } from '../services/common'
import { AUTH_TOKEN_RE, STAGE, Stages } from '../config'

export function* startup() {
  try {
    const tokenInUrl = yield call(services.extractTokenFromUrl)
    if (!!tokenInUrl) {
      // Local environment only
      yield call(services.authToken.set, tokenInUrl)
      const normalizedUrl = window.location.href.replace(AUTH_TOKEN_RE, '')
      window.location.assign(normalizedUrl)
      window.location.reload()
    } else {
      const token = yield select(selectors.selectToken)
      if (!!token) {
        const credentials = yield call(services.parseToken, token)
        yield put(actions.putCredentials(credentials))
      } else {
        yield call(services.redirectToSphinx)
      }
    }
  } catch (err) {
    trace(err)
    yield put(actions.authFailure(err.message))
    yield call(services.authToken.remove)
  }
}

export function* handleLogoutSaga(action: ILogoutAction) {
  if (STAGE === Stages.local) {
    // Local environment only
    trace(STAGE)
    yield call(services.authToken.remove)
    yield call(services.clearCache)
    alert('You have been logged out')
  } else {
    yield call(services.logout)
  }
}

export function* authWatcher() {
  yield fork(startup)
  yield takeEvery(types.LOGOUT, handleLogoutSaga)
}
